export const handleErrorLogging = (
  error: Error,
  setFn: React.Dispatch<React.SetStateAction<Error | null>>
) => {
  console.error(error.message);
  setFn(error);
};
